// src/components/Welcome.js
import React from 'react';
import useAuth from "../hooks/useAuth";
import { useAxiosPrivate } from "./../hooks/useAxiosPrivate";
import { useState, useEffect } from "react";

const Welcome = () => {
    const { auth } = useAuth();
    const [announcements, setAnnouncements] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchAnnouncements = async () => {
            try {
                //const response = await axios.get('/api/announcements');

                const response = await axiosPrivate.get(`${baseURL}/announcements/`);

                console.log("announcements: ", response);

                setAnnouncements(response.data);
            } catch (err) {
                console.error("Failed to load announcements", err);
            }
        };

        fetchAnnouncements();
    }, []);

    return (
        <div className="welcome-container">
            <h1>Welcome back, {auth.user}!</h1>

            <div className="announcement-board">
                {/*    <h3>Important Notices</h3>  */}
                {announcements.length > 0 ? (
                    <div style={{ textAlign: 'justify' }}>
                        {announcements.map((item) => (
                            <div key={item.announcement_id} style={{ marginBottom: '1rem' }}>
                                <strong>{item.title}</strong>
                                <p style={{ margin: '0.5rem 0' }}>{item.text}</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No current announcements</p>
                )}
            </div>
        </div>
    );
};

export default Welcome;